module.exports = __webpack_public_path__ + "img/balti-masala.4154c5ea.jpeg";